<template>
  <div class="img-upload">
    <van-nav-bar
      title="百度小程序短带长zip包处理"
    />
    <div class="img-upload-btn">
      <van-uploader
        accept="application/zip"
        :after-read="afterRead">
        <van-button
          icon="plus"
          type="primary">上传文件
        </van-button>
      </van-uploader>
    </div>
    <div class="img-upload-btn">
      <van-button @click="deleteAll" type="danger">清空所有的zip包</van-button>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { NavBar, Field, Button, Toast, Uploader, Dialog, Overlay, Loading } from 'vant';
  import axios from 'axios'

  export default {
    name: 'img_handle',
    data() {
      return {
        show: false
      }
    },
    async mounted() {

    },
    methods: {
      async afterRead(file) {
        console.log(file)
        this.show = true
        let params = new FormData()
        params.append('zip', file.file)
        let config = {
          headers: { //添加请求头
            'Content-Type': 'multipart/form-data'
          }
        }
        const res = await axios.post('http://10.124.64.100:8360/bd/base/handleImg', params, config)
        if (res && res.data && res.data.url) {
          Toast.success('处理成功')
          window.location.href = res.data.url
        } else {
          //否则 Toast 提示
          Toast.fail('上传失败')
        }
        this.show = false
      },
      async deleteAll(){
        Dialog.confirm({
          title: '确定？',
          message: '要删除吗？其实也没有关系',
        })
          .then(async () => {
            this.show = true
            const res = await axios.post('http://10.124.64.100:8360/bd/base/deleteAllZip')
            this.show = false
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Uploader.name]: Uploader,
      [NavBar.name]: NavBar,
      [Overlay.name]: Overlay,
      [Loading.name]: Loading
    }
  }
</script>

<style>
  .img-upload {
    width: 500px;
    margin: 50px auto;
  }

  .img-upload-btn {
    margin: 50px auto;
    text-align: center;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>
